export default "__VITE_ASSET__2c1cb767__"